<script>
    import { createEventDispatcher } from "svelte";
    import Button from "@smui/button";
    import { Icon } from "@smui/icon-button";
    import { mdiSendOutline } from "@mdi/js";
    import { _ } from "svelte-i18n";

    export let disabled = false;

    const dispatch = createEventDispatcher();
</script>

<Button class="{disabled ? 'grey' : 'tescoblue'} white-text pr-4" title={$_("send")} data-qa="ds-send-btn" on:click={() => dispatch("sendDSClicked")} {disabled}>
    <Icon tag="svg" viewBox="0 0 24 24" class="pr-0 pl-1">
        <path fill="currentColor" d={mdiSendOutline} />
    </Icon>
    {$_("send")}
</Button>
